module.exports = __webpack_public_path__ + "img/qrcode_bg.bf413267.png";